import { render, staticRenderFns } from "./gallery-modal.vue?vue&type=template&id=4881f22b&"
import script from "./gallery-modal.vue?vue&type=script&lang=js&"
export * from "./gallery-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4881f22b')) {
      api.createRecord('4881f22b', component.options)
    } else {
      api.reload('4881f22b', component.options)
    }
    module.hot.accept("./gallery-modal.vue?vue&type=template&id=4881f22b&", function () {
      api.rerender('4881f22b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/gallery/gallery-modal.vue"
export default component.exports